import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const GetCalibrationHistoryRequest = z.object({
  limit: z.number().int().positive().optional(),
})

export type GetCalibrationHistoryRequest = z.infer<typeof GetCalibrationHistoryRequest>

export const CalibrationHistoryEntry = z.object({
  appId: z.string(),
  calibrationId: z.string(),
  calibrationUrl: z.string(),
  timestamp: z.string(),
})

export type CalibrationHistoryEntry = z.infer<typeof CalibrationHistoryEntry>

export const GetCalibrationHistoryResponse = z.object({
  calibrations: z.array(CalibrationHistoryEntry),
})

export type GetCalibrationHistoryResponse = z.infer<typeof GetCalibrationHistoryResponse>

export const getCalibrationHistoryDeclaration = endpointDeclaration(
  GetCalibrationHistoryRequest,
  GetCalibrationHistoryResponse,
)
